/**
 * contractsFilterFields.js
 *
 * Advanced filter field catalog for the top-level Contracts grid. Field keys and operators
 * match ContractDynamicSpecification.java's leaf handling on the backend field-for-field.
 */

const TEXT_OPS = ["CONTAINS", "EQ"];
const DATE_OPS = ["GTE", "LTE", "EQ"];

export const CONTRACT_STATUS_OPTIONS = ["DRAFT", "ACTIVE", "EXPIRED"];
export const CONTRACT_PAYMENT_METHOD_OPTIONS = ["PREPAID", "COLLECT"];

export const CONTRACT_RULE_FIELDS = [
  {
    key: "contractCode", label: "Contract Code", type: "text", group: "Contract",
    ops: TEXT_OPS, backendField: "contractCode", placeholder: "e.g. CNT-00123",
  },
  {
    key: "status", label: "Status", type: "select", group: "Contract",
    options: CONTRACT_STATUS_OPTIONS, ops: ["EQ", "NEQ"], backendField: "status",
  },
  {
    key: "paymentMethod", label: "Payment Method", type: "select", group: "Contract",
    options: CONTRACT_PAYMENT_METHOD_OPTIONS, ops: ["EQ", "NEQ"], backendField: "paymentMethod",
  },
  {
    key: "officeCode", label: "Office Code", type: "text", group: "Contract",
    ops: TEXT_OPS, backendField: "officeCode", placeholder: "e.g. DIAMOND-MET",
  },

  { key: "effectiveDate", label: "Effective Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "effectiveDate" },
  { key: "expirationDate", label: "Expiration Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "expirationDate" },
];
